import { Col, Container, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { PageTitle } from 'shared/components/Fonts';
import { DataDisplay, DataItem } from 'shared/components/DataDisplay';
import { AssociateCardToCostCentreForm} from '../../components/AssociateCardToCostCentreForm/AssociateCardToCostCentreForm';
import { IconName } from '@orbita-ui/core';

import { CustomBreadcrumb } from '../../../../shared/components/CustomBreadcrumb';
import { Tarjeta } from '../../models/Tarjeta';

export function AssociateCardToCostCenterPage() {
  const breadcrumbData: {
    icon: IconName;
    items: string[];
    lastItem: string;
  } = {
    icon: 'PaymentCardIcon',
    items: ['Organización'],
    lastItem: 'Asociar tarjeta a Centro de Costos',
  };

  const location = useLocation();
  const navigate = useNavigate();
  const cardData: Tarjeta = location.state?.cardData;

  useEffect(() => {
    if (!cardData) {
      console.error('No se encontraron datos de la tarjeta. Redirigiendo...');
      navigate('/tarjetas');
    }
  }, [cardData, navigate]);

  const cardInfoItems: DataItem[] = useMemo(() => {
    if (!cardData) return [];
    return [
      { label: 'Número de Tarjeta', value: cardData.numero },
      { label: 'Denominación', value: cardData.denominacion },
      { label: 'Cuenta', value: cardData.numeroCuenta },
    ];
  }, [cardData]);

  return (
    <Container fluid>
      <CustomBreadcrumb
        icon={breadcrumbData.icon}
        items={breadcrumbData.items}
        lastItem={breadcrumbData.lastItem}
      />

      <Row className="mb-3">
        <PageTitle>Asociar tarjeta a Centro de Costos</PageTitle>
      </Row>

      <Row>
        <Col xs={12} className="mb-4">
          <DataDisplay title="Datos de la tarjeta" items={cardInfoItems} />
        </Col>
        <Col xs={12}>
          <AssociateCardToCostCentreForm cardData={cardData} />
        </Col>
      </Row>
    </Container>
  );
}
